import React from "react";
import adhdSeed from "./data/adhdSeed";

export default function PDADHDHelp() {
  const copyTask = (task) => {
    const text = `Day ${task.day}
${task.todoTitle}

Objective: ${task.objective}
Tags: ${task.tags.join(", ")}`;

    navigator.clipboard.writeText(text);

    alert(`📋 Day ${task.day} copied`);
  };

  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-cyan-500/30 bg-gradient-to-br from-cyan-950 to-gray-900 p-2">
        <h2 className="text-xs lg:text-sm font-bold text-cyan-300">
          🧠 Full 90-Day PurpleDoor Attention & Focus BOS
        </h2>
        <p className="mt-2 text-[11px] lg:text-xs text-gray-300">
          A family-driven Attention & Focus Improvement Operating System.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-2">
        <div className="rounded-xl border border-cyan-500/20 bg-gray-900 p-2">
          <h3 className="text-xs lg:text-sm font-semibold text-cyan-300 mb-1">
            Phase 1 (Days 1-30)
          </h3>
          <div className="space-y-1 text-[10px] lg:text-xs">
            <div>👀 Observe</div>
            <div>🔍 Identify</div>
            <div>❤️ Connect</div>
            <div>😴 Sleep Reset</div>
          </div>
        </div>

        <div className="rounded-xl border border-cyan-500/20 bg-gray-900 p-2">
          <h3 className="text-xs lg:text-sm  font-semibold text-cyan-300 mb-1">
            Phase 2 (Days 31-60)
          </h3>
          <div className="space-y-1 text-[10px] lg:text-xs">
            <div>🍎 Brain Fuel</div>
            <div>🏃 Movement</div>
            <div>🎯 Focus Training</div>
            <div>📋 Organization</div>
            <div>📵 Attention Protection</div>
          </div>
        </div>
        <div className="rounded-xl border border-cyan-500/20 bg-gray-900 p-2">
          <h3 className="text-xs lg:text-sm  font-semibold text-cyan-300 mb-1">
            Phase 3 (Days 61-90)
          </h3>
          <div className="space-y-1 text-[10px] lg:text-xs">
            <div>🌟 Confidence</div>
            <div>😊 Emotional Regulation</div>
            <div>🚀 Independence</div>
            <div>🦋 Renewal</div>
          </div>
        </div>
      </div>

      {/* Transformation */}
      <div className="rounded-xl border border-green-500/20 bg-green-950/20 p-2">
        <h3 className="font-semibold text-xs lg:text-sm text-green-300 mb-1">
          🚀 Expected Transformation
        </h3>

        <div className="flex flex-wrap items-center gap-2 text-[10px] lg:text-xs">
          <span>😵 Distracted</span>
          <span>⬇️</span>
          <span>👀 Aware</span>
          <span>⬇️</span>
          <span>📋 Structured</span>
          <span>⬇️</span>
          <span>🎯 Focused</span>
          <span>⬇️</span>
          <span>😊 Regulated</span>
          <span>⬇️</span>
          <span>🌟 Confident</span>
          <span>⬇️</span>
          <span>🚀 Growing</span>
        </div>
      </div>

      {/* Tasks */}
      <div className="rounded-xl border border-gray-700 bg-gray-900">
        <div className="sticky top-0 bg-gray-900 border-b border-gray-700 px-4 py-2">
          <h3 className="text-xs lg:text-sm font-semibold text-cyan-300">
            📋 Guided 90-Day Attention Activities
          </h3>

          <p className="text-[10px] lg:text-xs text-gray-400 mt-1">
            Click Copy and paste into your PurpleDoor Daily Task Input.
          </p>
        </div>

        <div className="p-2">
          {adhdSeed.map((task) => (
            <div
              key={task.day}
              className="border-b border-gray-800 p-1 hover:bg-gray-800/40 transition"
            >
              <div className="flex justify-between gap-3">
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-cyan-300 text-[10px] lg:text-xs font-semibold">
                      Day {task.day}
                    </span>

                    <span className="text-[10px] lg:text-xs text-gray-200">
                      {task.date}
                    </span>
                  </div>

                  <div className="mt-1 text-[10px] lg:text-xs text-white font-medium">
                    {task.todoTitle}
                  </div>

                  <div className="mt-2 flex flex-wrap gap-2">
                    <span className="px-2 py-1 rounded-full text-[10px] lg:text-xs bg-cyan-900 text-cyan-200">
                      🎯 {task.objective}
                    </span>

                    {task.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-1 rounded-full text-[10px] lg:text-xs bg-gray-800 text-gray-300"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                </div>

                <button
                  onClick={() => copyTask(task)}
                  className="w-fit px-1 py-1 rounded-lg text-white text-xs transition"
                >
                  📋
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}